import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { trackPromise } from 'react-promise-tracker';
import { fetchWrapper } from '_utils/fetch-wrapper';

// create slice

const name = 'master';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const masterActions = { ...slice.actions, ...extraActions };
export const masterReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        portalData: [],
        roleList: null,
        document: null,
        supportDetails: null
    }
}

function createExtraActions() {
    // const baseUrl = `${process.env.REACT_APP_API_URL}/master`;
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/Master`;

    return {
        getPortalData: getPortalData(),
        getNondisclosureDocument: getNondisclosureDocument(),
        saveRole:saveRole(),
        getAllRoles:getAllRoles(),
        deleteRole:deleteRole(),
        updateRole:updateRole(),
    };

    function getPortalData() {
        return createAsyncThunk(
            `${name}/getPortalData`,
            async (_, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.get(`${baseUrl}/GetPortalDetails`));
                    return response;
                }
                catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

    function getNondisclosureDocument() {
        return createAsyncThunk(
            `${name}/getNondisclosureDocument`,
            async (_, { rejectWithValue }) => {
                try {
                    const response = await trackPromise(fetchWrapper.get(`${baseUrl}/download`));
                    return response;
                } catch (error) {
                    return rejectWithValue(error);
                }
            }
        );
    }

     function saveRole() { 
            return createAsyncThunk(
                `${name}/saveRole`,
                async (data, { rejectWithValue }) => {
                    try {
                        const response = await trackPromise(fetchWrapper.post(`${baseUrl}/CreateRole`,{roles: data}));
                        return response;
                    } 
                    catch (error) {
                        return rejectWithValue(error);
                    }
                }
            );
        }
        function updateRole() { 
            return createAsyncThunk(
                `${name}/updateRole`,
                async (data, { rejectWithValue }) => {
                    try {
                        const response = await trackPromise(fetchWrapper.put(`${baseUrl}/UpdateRole`, {Data:data}));
                        return response;
                    }
                    catch (error) {
                        return rejectWithValue(error);
                    }
                }
            );
        }
        function getAllRoles() {
            return createAsyncThunk(
                `${name}/getAllRoles`,
                async (_, { rejectWithValue }) => {
                    try {
                        const response = await trackPromise(fetchWrapper.get(`${baseUrl}/GetAllRoles`));
                        return response;
                    }
                    catch (error) {
                        return rejectWithValue(error);
                    }
                }
            );
        }
        function deleteRole() {
            return createAsyncThunk(
                `${name}/deleteRole`,
                async (data, { rejectWithValue }) => {
                    try {
                    const url = new URL(`${baseUrl}/DeleteRole`);
                    // url.searchParams.append('roleId', id);
                    if(data.roleId){
                        url.searchParams.append('rolId', data.roleId);
                    }
                    if(data.deletedBy){
                        url.searchParams.append('deletedBy', data.deletedBy)
                    }
                    const response = await trackPromise(fetchWrapper.delete(url.toString()));
                    return response;
                    }
                    catch (error) {
                        return rejectWithValue(error);
                    }
                }
            );
        }
}

function createExtraReducers() {
    return (builder) => {
        getPortalData();
        getNondisclosureDocument();
        getAllRoles();

        function getPortalData() {
            var { pending, fulfilled, rejected } = extraActions.getPortalData;
            builder
                .addCase(pending, (state) => {
                    state.portalData = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    const result = action.payload;
                    state.portalData = result?.Data;
                })
                .addCase(rejected, (state, action) => {
                    state.portalData = { error: action.error };
                });
        };

        function getAllRoles() {
            var { pending, fulfilled, rejected } = extraActions.getAllRoles;
            builder
                .addCase(pending, (state) => {
                    state.roleList = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    const result = action.payload;
                    state.roleList = result?.Data;
                })
                .addCase(rejected, (state, action) => {
                    state.roleList = { error: action.error };
                });
        };

        function getNondisclosureDocument() {
            var { pending, fulfilled, rejected } = extraActions.getNondisclosureDocument;
            builder
                .addCase(pending, (state) => {
                    state.document = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.document = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.document = { error: action.error };
                });
        };

    };
}